import TextInput from"react-native-web/dist/exports/TextInput";export default TextInput;